import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';

export const logout = () => {
  console.info('logging out');
  window.location.assign(getLogoutUrl());
};

function getLogoutUrl(): string {
  const logoutUrl = `${serviceUrls.AUTH.BASE()}/auth/olweb/logout?returnUrl=${getPhpLogoutUrl()}`;
  console.info(logoutUrl);
  return logoutUrl;
}

function getPhpLogoutUrl(): string {
  return `${serviceUrls.WEB_ONCOLENS.BASE()}/users/logout`;
}
